module.exports = __webpack_public_path__ + "media/images/search/marker-455806222a70a13e5c6fc2546d95812c.svg";